import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { TranslateDirective } from "@ngx-translate/core";
import { HandelssortimentDTO } from "~app/common/models/handelssortiment/HandelssortimentDTO";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IHandelssortimentProdukt } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { ModelActionService } from "../../../../../common/services/cqs/model-action.service";
import { ProduktRadComponent } from "./produkt-rad/produkt-rad.component";

@Component({
    selector: "rask-handelssortiment-produkt",
    styleUrls: ["./hs-produkt.component.scss"],
    templateUrl: "./hs-produkt.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateDirective,
        ProduktRadComponent
    ]
})
export class HsProduktComponent {
    @Output() changed = new EventEmitter();
    @Input() disabled: boolean;
    @Input() handelssortiment: HandelssortimentDTO;
    @Input() produkter: IHandelssortimentProdukt[];
    @Input() validationContext: IValidationContext;

    private readonly modelActionService = inject(ModelActionService);

    addHandelssortimentProdukt() {
        const produkt = {
            andel: undefined,
            fordelningstyp: "",
            produktId: undefined,
            rowVersion: ""
        } as IHandelssortimentProdukt;
        this.modelActionService.addNewChildModel(produkt, "HandelssortimentProdukt", this.handelssortiment);
        this.produkter.push(produkt);
        this.changed.emit(true);
    }

    produktChanged() {
        this.changed.emit(true);
    }

    removeHandelssortimentProdukt(produkt: IHandelssortimentProdukt) {
        const index = this.produkter.indexOf(produkt);
        const removed = this.produkter.splice(index, 1)[0];
        this.modelActionService.removeModel(removed, "HandelssortimentProdukt");
        this.changed.emit(true);
    }
}
